import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ProductBlock from "./ProductBlock";
import Image from "@shared/components/contents/image/Image";
const ProductBlockPreview = () => {
    return (_jsx(ProductBlock, { image: _jsx(Image, { file: { url: "/exemple-image.jpg" }, disableLazy: true }), title: "IDP Pro", subtitle: "Sous titre", description: "Description", link: {
            url: "/",
            title: "Lien vers la page",
        } }));
};
export default ProductBlockPreview;
